<div
  class="progress-bar"
  [style.width]="(currentValue / maxValue) * 100 + '%'"
></div>
